module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-3@3x.2cbde84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-3@3x.png
// module id = xVpg
// module chunks = 18